var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgQuestions = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.3 202.7C166.8 208.5 155 211.6 142.8 211.6C103.6 211.6 71.8 179.8 71.8 140.6C71.8 101.4 103.6 69.6 142.8 69.6C182 69.6 213.8 101.4 213.8 140.6C213.8 152.8 210.7 164.6 204.9 175.1L207.4 205.2L177.3 202.7ZM174 188.2L191.8 189.7L190.3 171.9L191.5 169.9C196.8 161.1 199.6 151.1 199.6 140.7C199.6 109.3 174.2 83.9 142.8 83.9C111.4 83.9 86 109.3 86 140.6C86 171.9 111.4 197.4 142.8 197.4C153.2 197.4 163.3 194.6 172 189.3L174 188.2ZM142.8 176.1C138.9 176.1 135.7 172.9 135.7 169C135.7 165.1 138.9 161.9 142.8 161.9C146.7 161.9 149.9 165.1 149.9 169C149.9 172.9 146.8 176.1 142.8 176.1ZM149.9 154.8H135.7V147.7C135.7 142.5 138.4 138.5 142.6 135.1C143.9 134.1 144.3 133.8 146.6 132.4C148.6 131.1 149.9 128.9 149.9 126.4C149.9 122.5 146.7 119.3 142.8 119.3C138.9 119.3 135.7 122.5 135.7 126.4H121.5C121.5 114.6 131 105.1 142.8 105.1C154.6 105.1 164.1 114.6 164.1 126.4C164.1 133.8 160.3 140.5 154.2 144.4C152.4 145.5 152.2 145.7 151.5 146.2C150.3 147.1 149.9 147.7 149.9 147.7V154.8Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuestions, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/questions.a75ab29e.svg";
export { ForwardRef as ReactComponent };